export default "__VITE_ASSET__CkqKCcs9__"